import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {KnownPlatform, PlatformService} from '../platform.service';
import {AddOffer, AddProduct, ProductOffering, UpgradeProtectionType} from '@uofu-uss-aux/software-catalog-ng-core';
import {LicensingService} from '../licensing.service';
import {PlatformIconComponent} from '../../svg/platform-icon/platform-icon.component';
import {InfoCircleComponent} from '../../svg/info-circle/info-circle.component';
import {AlertTriangleIconComponent} from '../../svg/alert-triangle-icon/alert-triangle-icon.component';
import {CurrencyPipe, NgIf, TitleCasePipe} from '@angular/common';
import {UnderscoreToSpacePipe} from '../../formatting/underscore-to-space.pipe';

@Component({
  selector: 'app-product-offering',
  templateUrl: './product-offering.component.html',
  styleUrls: ['./product-offering.component.scss'],
  inputs: ['product', 'offer'],
  standalone: true,
  imports: [
    PlatformIconComponent,
    InfoCircleComponent,
    AlertTriangleIconComponent,
    CurrencyPipe,
    TitleCasePipe,
    NgIf,
    UnderscoreToSpacePipe
  ]
})
export class ProductOfferingComponent extends AddProduct(AddOffer(Object)) implements OnInit {

  knownPlatform = KnownPlatform.web;

  anyOfferingsHaveAnyProtection = false;

  @Output()
  addToCartEmitter = new EventEmitter<ProductOffering>();

  constructor(private readonly platformService: PlatformService,
              private readonly licensingService: LicensingService) {
    super();
  }

  ngOnInit(): void {
    this.knownPlatform = this.platformService.findPlatform(this.platform);
    this.anyOfferingsHaveAnyProtection = this.licensingService.productHasAnyOfferingsThatHaveProtection(this.product);
  }

  addToCart(): void {
    this.addToCartEmitter.emit(this.offer);
  }

  get includesUpgradeProtection(): boolean {
    return this.offer?.upgradeProtectionType === UpgradeProtectionType.Included;
  }

  get upgradeProtectionOnly(): boolean {
    return this.offer?.upgradeProtectionType === UpgradeProtectionType.UpgradeProtectionOnly;
  }

  get hasNoProtection(): boolean {
    return !this.includesUpgradeProtection && !this.upgradeProtectionOnly;
  }

}
